import { AnyAction } from 'redux'

import { CONTENT_UPDATE } from '~/app/store/constants'
import type { GalleryProductProductOptionsGroupsByProductKey } from 'shared/types/gallery/product'
import type { State } from 'shared/types/gallery/state'

const initialState: State.ProductOptionsByProductKeyState = {}

export function reducer(state: State.ProductOptionsByProductKeyState = initialState, action: AnyAction): State.ProductOptionsByProductKeyState {
  switch (action.type) {
    case CONTENT_UPDATE:
      return {
        ...action.payload.productOptionsByProductKeyMap,
      }
    default:
      return state
  }
}

export const productOptionsByProductKeySelector = (state: State.GlobalState): GalleryProductProductOptionsGroupsByProductKey => state.productOptionsByProductKey
